export const generateRaceKey = (date, trackId, productId, raceIndex) =>
    `${date}.${trackId}.${productId}.${raceIndex}`;
